import React, { useContext, useState, useEffect } from 'react';
import { jwtDecode } from "jwt-decode";
import AuthContext from '../contexts/index'
import '../styles/login.css';


function Login() {
    const { authError, logout } = useContext(AuthContext);
    const [isInFbBrowser, setIsInFbBrowser] = useState(false);

    useEffect(() => {
        // Clear any expired session on Login page load
        const storedUser = JSON.parse(localStorage.getItem('user'));
        if (storedUser?.credential) {
            try {
                const decoded = jwtDecode(storedUser.credential);
                const now = Math.floor(Date.now() / 1000);
                if (!decoded.exp || decoded.exp <= now) {
                    // Token is expired, clear localStorage
                    logout();
                }
            } catch (e) {
                // Invalid token, clear it
                logout();
            }
        }

        // Detect if in Facebook in-app browser
        const ua = navigator.userAgent || navigator.vendor || window.opera;
        const isFbInApp = ua.includes('FBAV') || ua.includes('FB4A') || ua.includes('[FB');
        setIsInFbBrowser(isFbInApp);
    }, [logout]);

    const handleOpenInBrowser = () => {
        // Try Android intent first
        if (/Android/.test(navigator.userAgent)) {
            window.location.href = 'intent://oscarparties.com#Intent;scheme=https;package=com.android.chrome;end';
        } else if (/iPad|iPhone|iPod/.test(navigator.userAgent)) {
            // iOS: open in Safari
            window.location.href = 'https://oscarparties.com';
        }
    };

    return (
        <div className="App min-vh-100">
            {isInFbBrowser && (
                <div className="fb-browser-banner">
                    <div className="banner-content">
                        <p className="banner-text">For the best login experience, open this link in your browser</p>
                        <button onClick={handleOpenInBrowser} className="banner-button">
                            Open in Browser
                        </button>
                    </div>
                </div>
            )}
            { authError && (
                <div className="alert alert-danger" data-testid="auth-error" role="alert">
                    {authError}
                </div>
            )}
            <div className="login-container">
                {/* One Tap will render here automatically via useGoogleOneTapLogin */}
            </div>
        </div>
    );
}

export default Login;
